"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constellation_1 = require("@zillow/constellation");
const react_1 = __importDefault(require("react"));
const tab_click_1 = require("../../utils/clickstream/tab-click");
const RateCardsContainer_1 = __importDefault(require("./RateCardsContainer"));
const RateCardsContainerTabbed = ({ cardsInfo, }) => {
    const onClickHandler = (tabId) => {
        (0, tab_click_1.triggerTabClickEvent)({
            label: tabId,
            id: `rateCard - ${tabId}`,
        });
    };
    return (react_1.default.createElement(constellation_1.Box, null,
        react_1.default.createElement(constellation_1.Tabs, { defaultSelected: "most-popular" },
            react_1.default.createElement(constellation_1.Tabs.List, { justifyContent: "center" }, cardsInfo.map((group) => (react_1.default.createElement(constellation_1.Tabs.Tab, { key: group.id, id: group.id, onClick: () => onClickHandler(group.id) }, group.title)))),
            react_1.default.createElement(constellation_1.Tabs.Panels, null, cardsInfo.map((group) => (react_1.default.createElement(constellation_1.Tabs.Panel, { key: group.id, paddingBottom: "none", "aria-labelledby": group.id },
                react_1.default.createElement(RateCardsContainer_1.default, { cardsInfo: group.data }))))))));
};
exports.default = RateCardsContainerTabbed;
